export function HelpAndSupportPage(){
    return (<>
       <iframe src="https://help.gamesheet.app/" />
    </>)
}